import { api } from "../configs/axiosConfigs";

const ContractorRegistrationApiService = {
  inquiryAvailability: async (data) => {
    const response = await api.request({
      url: "ContractorRegistration/InquiryAvailability",
      method: "POST",
      data,
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  },

  // ثبت درخواست جدید پیمانکار (Public API - بدون نیاز به احراز هویت)
  submitRegistration: async (data) => {
    console.log("🔧 API Service: ارسال داده‌ها به سرور");
    console.log("📦 Registration data:", data);

    const response = await api.request({
      url: "ContractorRegistration/Register",
      method: "POST",
      data: data,
      headers: {
        "Content-Type": "application/json",
      },
    });

    console.log("✅ API Response:", response);
    return response.data;
  },

  // دریافت لیست درخواست‌های پیمانکاران برای کارشناسان (با احراز هویت)
  getRegistrations: async (status = null) => {
    const params = status ? { status } : {};
    const response = await api.request({
      url: "ContractorRegistration/GetRegistrations",
      method: "GET",
      params,
    });
    return response.data;
  },

  // دریافت جزئیات یک درخواست پیمانکار (با احراز هویت)
  getRegistrationById: async (id) => {
    const response = await api.request({
      url: "ContractorRegistration/GetRegistrationById",
      method: "GET",
      params: { id },
    });
    return response.data;
  },

  // به‌روزرسانی وضعیت درخواست پیمانکار (با احراز هویت)
  updateRegistrationStatus: async (data) => {
    const response = await api.request({
      url: "ContractorRegistration/UpdateStatus",
      method: "POST",
      data,
    });
    return response.data;
  },

  // دریافت آمار درخواست‌های پیمانکاران (با احراز هویت)
  getStatistics: async () => {
    const response = await api.request({
      url: "ContractorRegistration/GetStatistics",
      method: "GET",
    });
    return response.data;
  },

  // دریافت لیست استان‌ها
  getProvinces: async () => {
    const response = await api.request({
      url: "ContractorRegistration/GetProvinces",
      method: "GET",
    });
    return response.data;
  },

  // دریافت لیست تخصص‌ها
  getSpecialties: async () => {
    const response = await api.request({
      url: "ContractorRegistration/GetSpecialties",
      method: "GET",
    });
    return response.data;
  },

  // دریافت لیست شهرها
  getCities: async () => {
    const response = await api.request({
      url: "ContractorRegistration/GetCities",
      method: "GET",
    });
    return response.data;
  },

  // دریافت لیست شرکت‌های توزیع برق (برای وندور لیست)
  getDistributionCompanies: async () => {
    const response = await api.request({
      url: "ContractorRegistration/GetDistributionCompanies",
      method: "GET",
    });
    return response.data;
  },

  // دانلود PDF درخواست پیمانکار
  downloadRegistrationPDF: async (registrationId) => {
    const response = await api.request({
      url: `ContractorRegistration/DownloadPDF?id=${registrationId}`,
      method: "GET",
      responseType: "blob",
    });
    return response.data;
  },

};

export default ContractorRegistrationApiService;
